<template>
  <div class="weather">
    <!-- 时间面板 -->
    <timePanel :updateTime="weather.storeTime"/>
    <!-- 操作面板 -->
    <Handlepael 
      @refresh="refresh"
      @repair="repair"
      @dateChange="onDateChange"/>

    <!-- 数据详情的抽屉 -->
    <DetailDrawer 
      v-if="mapRender"
      @close="mapRender.drawer.visible = false"
      :drawer="mapRender.drawer.visible"
      :data="mapRender.drawer.data"/>

    <!-- !!!主要地图内容!!! -->
    <div id="container"></div>
  </div>
</template>

<script>
import MapRender from '@/model/MapRender.js';
import Weather from '@/model/Weather.js';
import TimePanel from '@/components/TimePanel.vue';
import Handlepael from '@/components/HandlePanel.vue';
import DetailDrawer from '@/components/DetailDrawer.vue';

export default {
  name: 'weather',
  components: {
    TimePanel,
    Handlepael,
    DetailDrawer,
  },
  data() {
    return {
      weather: new Weather(),
      mapRender: new MapRender(),
    }
  },
  mounted() {
    document.title = '全国天气面板'
    this.mapRender = new MapRender();
  },
  watch: {
    weather: {
      deep: true,
      handler: function(w) {
        if (w.data && w.data.length) {
          this.mapRender.setData(w.data);
        }
      }
    }
  },
  methods: {
    refresh() {
      this.weather.fetchLiveData();
    },
    async repair() {
      await this.weather.fetchLiveData(this.weather.storeTime);
      this.mapRender.setData(this.weather.data);
    },
    async onDateChange(date) {
      await this.weather.fetchLiveData(date);
      this.mapRender.setData(this.weather.data);
    }
  }
}
</script>

<style lang="less">
  .weather {
    #container {
      width: 100vw;
      height: 100vh;
    }
  }
</style>
